import { create } from 'zustand';

/**
 * The funnel page the viewer is on (`/quiz/{slug}`), read by `InlineAuth` so a sign-in
 * there carries the quiz (`sourceQuiz`) and the DM reply it was opened from (`sourceReply`,
 * which refers the pair when a teammate word sent it). Empty elsewhere.
 */
interface FunnelState {
  funnel: { tutorUsername: string; quizId: string; replyId: string | null } | null;
  setFunnel: (funnel: FunnelState['funnel']) => void;
}

export const useFunnel = create<FunnelState>((set) => ({
  funnel: null,
  setFunnel: (funnel) => set({ funnel }),
}));
